<div class="d-flex flex-column h-100">
  <div class="modal-header pt-3">
    <h2 class="modal-title">Add New Addendum</h2>
    <span role="button" class="ms-auto" (click)="close()">
      <svg-icon name="modal-close-menu" class="svg-32"></svg-icon>
    </span>
  </div>
  <form class="modal-body overflow-hidden h-15" [formGroup]="form" (ngSubmit)="submit()">
    <div class="mb-3">
      <generic-dropdown
        class="w-100"
        [items]="builderReferences()"
        [label]="'Builder Reference'"
        formControlName="builderReference"
        [allowSearch]="true"
        [clearable]="false"
        [required]="true"
        [errormessage]="'Builder Reference is required'"
        placeholder="Select Builder Reference"
      />
    </div>
  </form>
  <div class="modal-footer">
    <button class="btn btn-shadow" type="button" (click)="close()">Cancel</button>
    <button class="btn btn-primary" type="button" appBtnLoader="deal-add-addendum" (click)="submit()">
      Add Addendum
    </button>
  </div>
</div>
